/*
* Copyright © 2021 Firecrest Clinical, Ltd.
* All rights reserved.
*/

import {Component, OnInit} from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import {FcAgUtilsService} from '../fc-ag-services/fc-ag-utils.service';
import { TooltipPosition } from '../fc-tooltip/fc-tooltip.component';
import {FcAgContextComponent} from './fc-ag-context.component';

/**
 * Date picker component with Angular.
 */
@Component({
    selector: 'fc-ag-context-menu',
    templateUrl: './fc-ag-context-menu.component.html',
    styleUrls: ['./fc-ag-context-menu.component.scss']
})
export class FcAgContextMenuComponent extends FcAgContextComponent implements OnInit {

    /**
     * Context menu options.
     */
    options: FcAgContextMenuOptions;
    
    private defaultOptions: FcAgContextMenuOptions = {
        contextClass: '',
        isContextMenuHidden: (menuItem: FcAgContextMenuItem) => {
            if (menuItem.isHidden) {
                return menuItem.isHidden({
                    menuItem: menuItem
                });
            }
            return false;
        },
        onContextMenuClick: (menuItem: FcAgContextMenuItem) => {
            if (!menuItem.isDisabled || !menuItem.isDisabled(menuItem)) {
                if (menuItem.onClick) {
                    menuItem.onClick({
                        menuItem: menuItem
                    });
                }
            }
        },
        menus: []
    };
    
    /**
     * FcAgDatePicker constructor.
     *
     * @param fcAgUtilsService FcAgUtilsService.
     */
    constructor(private fcAgUtilsService: FcAgUtilsService) {
        super();
    }

    /**
     * Angular life cycle.
     */
    ngOnInit() {
        this.fcAgUtilsService.extendConfig(this.options, this.defaultOptions);
    }

    /**
     * Render menu item.
     * 
     * @param menu FcAgContextMenuItem.
     * @returns String|SafeHtml.
     */
    renderMenuItem(menu: FcAgContextMenuItem): string|SafeHtml {
        if (menu.render) {
            return menu.render(menu);
        }
        return menu && menu.title;
    }
}

export interface FcAgContextMenuItem {
    title: string,
    class?: string,
    isHidden?: (context: any) => boolean,
    isDisabled?: (context: any) => boolean,
    onClick: (context: any) => void,
    render?: (menu: FcAgContextMenuItem) => string|SafeHtml,
    tooltip?: string,
    tooltipPosition?: TooltipPosition,
    tooltipClass?: string 
}

export interface FcAgContextMenuOptions {
    contextClass?: string,
    isContextMenuHidden?: (item:FcAgContextMenuItem) => boolean;
    onContextMenuClick?: (item:FcAgContextMenuItem) => void;
    menus: FcAgContextMenuItem[]
}